import angular from 'angular';

module.exports = angular.module('market.models.workOrder', [])
.factory('WorkOrder', function(odResource) {
  return odResource('/api/v1/work_orders/:path', { reference_number: '@reference_number' }, {
    get: {
      url: '/api/v1/work_orders/:reference_number',
      method: 'GET'
    },
    for_home_condition_report: {
      url: '/api/v1/work_orders/for_home_condition_report',
      method: 'GET',
      isArray: true,
    },
  });
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/models/work-order.js
 **/